import { Wrapper } from './style';
import UploadFileIcon from '../../../../../assets/icons/upload-file.svg?react';
import { ChangeEvent, HTMLAttributes, useEffect, useRef, useState } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import { TailSpin } from 'react-loader-spinner';

interface UploadFileProps extends HTMLAttributes<HTMLDivElement> {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
  progress?: number;
  disabled?: boolean;
  placeholder?: string;
  accept?: string;
}

export function UploadFile({
  onChange,
  isLoading,
  progress = 0,
  disabled,
  placeholder = 'Drag & Drop or Choose file to upload',
  accept,
  ...props
}: UploadFileProps) {
  const ref = useRef<HTMLInputElement>(null);
  const [isLoadingFaker, setIsLoadingFaker] = useState<boolean>(false);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;

    if (progress === 100) {
      interval = setInterval(() => setIsLoadingFaker(true), 2000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [progress]);

  const onClick = () => {
    ref.current?.click();
  };

  if (progress === 100 && isLoadingFaker) {
    return (
      <Wrapper>
        <div className="progress-bar">
          <TailSpin width={30} height={30} color="#7888F5" strokeWidth={3} />
        </div>

        <p>Almost uploaded...</p>
      </Wrapper>
    );
  }

  return (
    <Wrapper onClick={onClick} disabled={disabled} {...props}>
      {progress > 0 ? (
        <div className="progress-bar">
          <CircularProgressbar value={progress} text={`${progress}%`} strokeWidth={5} />
        </div>
      ) : (
        <div className="progress-bar">
          <UploadFileIcon />
        </div>
      )}

      <p>{placeholder}</p>
      <input
        ref={ref}
        type="file"
        style={{ display: 'none' }}
        onChange={onChange}
        disabled={isLoading || disabled}
        multiple
        accept={accept}
      />
    </Wrapper>
  );
}
